import { EnvironmentProviders, provideAppInitializer } from '@angular/core';

const QUALTRICS_URL = 'https://zn2r50qexuz9xlg4z-genesyscx.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2R50qeXUz9XLg4z';
const QUALTRICS_ZONE_ID = 'ZN_2R50qeXUz9XLg4z';

/**
 * Provides the application with the Qualtrics Website Feedback survey snippet
 * The button to open the survey comes from the script itself, we do not put a button on the DOM ourselves.
 * @returns app initializer provider
 */
export const provideQualtricsFeedbackSurvey = (): EnvironmentProviders =>
    provideAppInitializer(() => {
        const initializerFn = qualtricsFeedbackSurveyInitializer();
        return initializerFn();
    });

export const qualtricsFeedbackSurveyInitializer = () => {
    return async () => {
        await new Promise<void>((resolve) => {
            const go = () => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = QUALTRICS_URL;
                script.onload = () => resolve();
                script.onerror = () => resolve();
                document.body?.appendChild(script);
            };

            if (document.readyState === 'complete') {
                go();
            } else {
                window.addEventListener('load', () => go(), false);
            }

            // Create the placeholder div required by Qualtrics
            if (!document.getElementById(QUALTRICS_ZONE_ID)) {
                const div = document.createElement('div');
                div.id = QUALTRICS_ZONE_ID;
                document.body?.appendChild(div);
            }

            console.debug('[Injectors][QualtricsFeedbackSurveyInjector] Successfully injected.');
        });
    };
};
